import LegalPage from 'src/sections/legal/legal';

export default function FAQ() {
  return <LegalPage />;
}
